import { useDispatch } from "react-redux";
import type { AppDispatch } from "./index";

/**
 * Thunk-aware `dispatch` hook.
 *
 * react-redux v7's bare `useDispatch()` returned `Dispatch<any>`, which silently
 * accepted thunk action creators. v9 returns `Dispatch<UnknownAction>`, which
 * rejects them, so `dispatch(someThunk)` no longer type-checks.
 *
 * This binds the hook to the store's real `AppDispatch` (a `ThunkDispatch`) once,
 * centrally, instead of each call site passing `useDispatch<AppDispatch>()`.
 * Note the returned hook takes no type argument — the type is already applied.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
